import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { CATEGORY_CONSTANTS, SCREEN_TYPE } from "../../../../../constants";
import { MenuActionCreators } from "../../../../../redux/action-creators";
import { MenuSelectors, UISelectors } from "../../../../../redux/selectors";

export const useKambiNumberOfItemsPC = () => {
  const screenType = useSelector(UISelectors.screenType);

  const sportCategories = useSelector(MenuSelectors.sportCategories);
  const dispatch = useDispatch();
  const numberOfDisplayedItems = useSelector(
    MenuSelectors.numberOfDisplayedItems
  );

  useEffect(() => {
    let numberOfDisplayedItems = null;

    const totalNumberOfItems = sportCategories?.length;

    CATEGORY_CONSTANTS.SPECTATE_NUMBER_OF_CATEGORIES;
    numberOfDisplayedItems = Math.min(
      totalNumberOfItems,
      screenType === SCREEN_TYPE.REGULAR
        ? CATEGORY_CONSTANTS.LOW_NUMBER_OF_ITEMS_KAMBI - 1
        : CATEGORY_CONSTANTS.MAX_NUMBER_OF_ITEM_KAMBI - 1
    );

    dispatch(
      MenuActionCreators.setNumberOfDisplayedItems(numberOfDisplayedItems)
    );
  }, [sportCategories?.length, dispatch, screenType]);

  return numberOfDisplayedItems;
};
